var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtpPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_19976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7765 0.764893H8.96855C6.53655 0.764893 4.56055 2.74089 4.56055 5.17289V32.8369C4.56055 35.2689 6.53655 37.2449 8.96855 37.2449H24.7765C27.2085 37.2449 29.1845 35.2689 29.1845 32.8369V25.3889H26.1445V28.1249C26.1445 28.8849 25.5365 29.6449 24.6245 29.6449H9.12055C8.36055 29.6449 7.60055 29.0369 7.60055 28.1249V5.93289C7.60055 5.17289 8.20855 4.41289 9.12055 4.41289H24.7765C25.5365 4.41289 26.2965 5.02089 26.2965 5.93289V10.3409H29.3365V5.17289C29.3365 2.74089 27.3605 0.764893 24.7765 0.764893ZM16.8725 31.9249C17.6325 31.9249 18.3925 32.5329 18.3925 33.4449C18.3925 34.3569 17.6325 34.9649 16.8725 34.9649C15.9605 34.9649 15.3525 34.2049 15.3525 33.4449C15.3525 32.5329 16.1125 31.9249 16.8725 31.9249Z",
    fill: "#1A427D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.832 15.3568V20.3728C13.832 21.4368 14.744 22.3488 15.808 22.3488H31.464C32.528 22.3488 33.44 21.4368 33.44 20.3728V15.3568C33.44 14.2928 32.528 13.3808 31.464 13.3808H15.808C14.592 13.2288 13.832 14.1408 13.832 15.3568ZM28.88 16.2688C29.64 16.2688 30.4 16.8768 30.4 17.7888C30.4 18.5488 29.64 19.3088 28.88 19.3088C27.968 19.3088 27.36 18.5488 27.36 17.7888C27.36 17.0288 27.968 16.2688 28.88 16.2688ZM23.56 16.2688C24.472 16.2688 25.08 16.8768 25.08 17.7888C25.08 18.5488 24.472 19.3088 23.56 19.3088C22.8 19.3088 22.04 18.5488 22.04 17.7888C22.04 17.0288 22.8 16.2688 23.56 16.2688ZM18.392 16.2688C19.152 16.2688 19.912 16.8768 19.912 17.7888C19.912 18.5488 19.152 19.3088 18.392 19.3088C17.632 19.3088 16.872 18.5488 16.872 17.7888C16.872 17.0288 17.48 16.2688 18.392 16.2688Z",
    fill: "#1A427D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_19976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(0 0.00488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpPhone);
export default __webpack_public_path__ + "static/media/otp-phone.e56c625aee6b1ac61720533f888f2469.svg";
export { ForwardRef as ReactComponent };